import moment from 'moment-timezone';
export const defaultTimezone = 'America/Chicago';
moment.tz.setDefault(defaultTimezone);
export default moment;
